import PropTypes from 'prop-types';

import { removeCamelCase } from '../../../utils/util';

import PageButtons from './page-buttons/PageButtons';

import './table.scss';

const Table = ({ data, currentPage, totalPages, hiddenColumns, emptyMessage, onRowClick, onPageChange }) => {
  if (!data.length) {
    return <section className="table table--empty">{emptyMessage}</section>;
  }

  const handleRowClick = (object) => {
    if (!onRowClick) return;

    onRowClick(object);
  };

  const renderHeaders = () => {
    const keys = Object.keys(data[0]);

    return keys
      .filter((key) => !hiddenColumns.includes(key))
      .map((key, index) => {
        return <th key={index}>{removeCamelCase(key)}</th>;
      });
  };

  const renderRows = () => {
    return data.map((object, index) => {
      const row = [];

      for (const property in object) {
        if (!hiddenColumns.includes(property)) {
          const value = object[property];
          row.push(
            <td key={property} data-value={value}>
              {value === undefined || value === null || value === '' ? '-' : value}
            </td>
          );
        }
      }

      return (
        <tr key={index} style={{ cursor: onRowClick ? 'pointer' : 'initial' }} onClick={() => handleRowClick(object)}>
          {row}
        </tr>
      );
    });
  };

  return (
    <section className="table">
      <table>
        <thead>
          <tr>{renderHeaders()}</tr>
        </thead>
        <tbody>{renderRows()}</tbody>
      </table>

      {onPageChange && <PageButtons currentPage={currentPage} totalPages={totalPages} onPageChange={onPageChange} />}
    </section>
  );
};

Table.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  hiddenColumns: PropTypes.arrayOf(PropTypes.string),
  emptyMessage: PropTypes.string,
  onRowClick: PropTypes.func,
  onPageChange: PropTypes.func,
};

Table.defaultProps = {
  data: [],
  currentPage: 0,
  totalPages: 1,
  hiddenColumns: [],
  emptyMessage: 'No data to display',
  onRowClick: undefined,
  onPageChange: undefined,
};

export default Table;
